import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Historico from "../pages/historico/page";
import Funcionarios from "../pages/funcionarios/page";
import FuncionarioDetalhePage from "../pages/funcionarios/detalhe/page";
import Siadap from "../pages/siadap/page";
import Resumo from "../pages/resumo/page";
import LoginPage from "../pages/login/page";
import AdminPage from "../pages/admin/page";
import RelatorioFuncionarioPage from "../pages/relatorio/page";
import RelatoriosPage from "../pages/relatorios/page";
import RelatorioCarreiraPage from "../pages/relatorio-categoria/page";
import RelatorioGeneroPage from "../pages/relatorio-genero/page";
import PerfilPage from "../pages/perfil/page";
import FormacaoDashboardPage from "../pages/formacao/dashboard/page";
import AcoesFormacaoPage from "../pages/formacao/acoes/page";
import ParticipantesFormacaoPage from "../pages/formacao/participantes/page";
import PlanoFormacaoPage from "../pages/formacao/plano/page";
import DocumentosFormacaoPage from "../pages/formacao/documentos/page";
import RelatoriosFormacaoPage from "../pages/formacao/relatorios/page";
import CalendarioFormacaoPage from "../pages/formacao/calendario/page";
import EntidadesFormacaoPage from "../pages/formacao/entidades/page";
import AlertasFormacaoPage from "../pages/formacao/alertas/page";
import FuncionariosFormacaoPage from "../pages/formacao/funcionarios/page";
import FuncionarioFormacaoDetalhePage from "../pages/formacao/funcionarios/detalhe/page";
import RequisitosFormacaoPage from "../pages/formacao/requisitos/page";
import AvaliacoesFormacaoPage from "../pages/formacao/avaliacoes/page";
import FormadoresInternosPage from "../pages/formacao/formadores/page";
import NotificacoesFormacaoPage from "../pages/formacao/notificacoes/page";
import FormacaoOnboardingPage from "../pages/formacao/onboarding/page";
import PrivateRoute from "../components/feature/PrivateRoute";
import { AppLayout } from "../components/feature/AppLayout";
import ColaboradoresFormacaoPage from "../pages/formacao/colaboradores/page";
import IndicadoresFormacaoPage from "../pages/formacao/indicadores/page";


const routes: RouteObject[] = [
  { path: "/login", element: <LoginPage /> },
  {
    path: "/",
    element: <PrivateRoute><AppLayout /></PrivateRoute>,
    children: [
      { index: true, element: <Funcionarios /> },
      { path: "funcionarios", element: <Funcionarios /> },
      { path: "progressoes", element: <Home /> },
      { path: "funcionarios/:id", element: <FuncionarioDetalhePage /> },
      { path: "funcionarios/:id/relatorio", element: <RelatorioFuncionarioPage /> },
      { path: "siadap", element: <Siadap /> },
      { path: "historico", element: <Historico /> },
      { path: "resumo", element: <Resumo /> },
      { path: "relatorios", element: <RelatoriosPage /> },
      { path: "relatorios/categoria", element: <RelatorioCarreiraPage /> },
      { path: "relatorios/genero", element: <RelatorioGeneroPage /> },
      { path: "perfil", element: <PerfilPage /> },
      { path: "admin", element: <PrivateRoute requireAdmin><AdminPage /></PrivateRoute> },
      { path: "formacao", element: <FormacaoDashboardPage /> },
      { path: "formacao/acoes", element: <AcoesFormacaoPage /> },
      { path: "formacao/participantes", element: <ParticipantesFormacaoPage /> },
      { path: "formacao/plano", element: <PlanoFormacaoPage /> },
      { path: "formacao/documentos", element: <DocumentosFormacaoPage /> },
      { path: "formacao/relatorios", element: <RelatoriosFormacaoPage /> },
      { path: "formacao/calendario", element: <CalendarioFormacaoPage /> },
      { path: "formacao/entidades", element: <EntidadesFormacaoPage /> },
      { path: "formacao/alertas", element: <AlertasFormacaoPage /> },
      { path: "formacao/funcionarios", element: <FuncionariosFormacaoPage /> },
      { path: "formacao/funcionarios/:id", element: <FuncionarioFormacaoDetalhePage /> },
      { path: "formacao/requisitos", element: <RequisitosFormacaoPage /> },
      { path: "formacao/avaliacoes", element: <AvaliacoesFormacaoPage /> },
      { path: "formacao/formadores", element: <FormadoresInternosPage /> },
      { path: "formacao/notificacoes", element: <NotificacoesFormacaoPage /> },
      { path: "formacao/colaboradores", element: <ColaboradoresFormacaoPage /> },
      { path: "formacao/indicadores", element: <IndicadoresFormacaoPage /> },
      { path: "formacao/onboarding", element: <FormacaoOnboardingPage /> },
    ],
  },
  { path: "*", element: <NotFound /> },
];

export default routes;